<template>
  <div class="card-divider-container">
    <div class="card-divider-split-left grey lighten-1"></div>
    <div class="card-divider-split-right grey lighten-1"></div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.card-divider-split-left {
  flex-grow: 1;
  height: 1px;
  margin: 15px 0px;
}

.card-divider-split-right {
  width: 37px;
  height: 1px;
  margin: 15px 0px 15px 76px;
}

.card-divider-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}
</style>
